import { useQuery } from '@tanstack/react-query';
import { keyPointsKey, loadKeyPoints } from './helpers';
import type { KeyPointsAsset, UseKeyPointsArgs } from './types';

/**
 * A project's Key points on their own. Where `useExperienceAddons` loads
 * every add-on for the viewer, this reads just this one — for callers like
 * the experience edit page that want a single add-on's content, cached by
 * React Query across remounts. Needs a `QueryClientProvider` above it.
 */
export function useKeyPoints({
  apiBaseUrl,
  projectId,
  token,
}: UseKeyPointsArgs): KeyPointsAsset {
  const query = useQuery({
    queryKey: keyPointsKey(apiBaseUrl, projectId),
    queryFn: () => loadKeyPoints({ apiBaseUrl, projectId, token }),
    enabled: Boolean(apiBaseUrl && projectId && token),
    staleTime: 60_000,
    refetchOnWindowFocus: false,
  });

  return {
    content: query.data?.content ?? '',
    document: query.data?.document ?? null,
    assetId: query.data?.assetId,
    isLoading: query.isLoading,
    isError: query.isError,
    refetch: () => void query.refetch(),
  };
}
